import React from 'react';

const ManageClinicIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75 56.6667C85.1063 56.6667 93.3333 48.4396 93.3333 38.3333C93.3333 28.2271 85.1063 20 75 20C64.8938 20 56.6667 28.2271 56.6667 38.3333C56.6667 48.4396 64.8938 56.6667 75 56.6667ZM68.125 36.0417H72.7083V31.4583C72.7083 30.1979 73.7396 29.1667 75 29.1667C76.2604 29.1667 77.2917 30.1979 77.2917 31.4583V36.0417H81.875C83.1354 36.0417 84.1667 37.0729 84.1667 38.3333C84.1667 39.5938 83.1354 40.625 81.875 40.625H77.2917V45.2083C77.2917 46.4688 76.2604 47.5 75 47.5C73.7396 47.5 72.7083 46.4688 72.7083 45.2083V40.625H68.125C66.8646 40.625 65.8333 39.5938 65.8333 38.3333C65.8333 37.0729 66.8646 36.0417 68.125 36.0417Z"
        fill="#54B1CD"
      />
      <path
        d="M52.0833 38.3333C52.0833 41.5875 52.7708 44.6812 54.0083 47.5H22.2917C21.0313 47.5 20 46.4687 20 45.2083V31.4583C20 30.1979 21.0313 29.1666 22.2917 29.1666H54.0083C52.7708 31.9854 52.0833 35.0791 52.0833 38.3333Z"
        fill="#54B1CD"
      />
      <path
        d="M93.2875 52.0834C89.0937 57.6292 82.4708 61.25 75 61.25C67.5292 61.25 60.9063 57.6292 56.7125 52.0834H24.5833V127.708C24.5833 128.969 25.6146 130 26.875 130H38.3333V91.0417C38.3333 89.7813 39.3646 88.75 40.625 88.75H58.9583C60.2187 88.75 61.25 89.7813 61.25 91.0417V130H123.125C124.385 130 125.417 128.969 125.417 127.708V52.0834H93.2875ZM81.875 95.625H72.7083V72.7084H81.875V95.625ZM95.625 95.625H86.4583V72.7084H95.625V95.625ZM109.375 95.625H100.208V72.7084H109.375V95.625Z"
        fill="#54B1CD"
      />
      <path
        d="M130 31.4583V45.2083C130 46.4687 128.969 47.5 127.708 47.5H95.9917C97.2292 44.6812 97.9167 41.5875 97.9167 38.3333C97.9167 35.0791 97.2292 31.9854 95.9917 29.1666H127.708C128.969 29.1666 130 30.1979 130 31.4583Z"
        fill="#54B1CD"
      />
    </svg>
  );
};

export default ManageClinicIcon;
